import React from 'react'
import { Bar, Info, Title, Sub, CtaButton } from './StickyCta.elements'
import useShowStickyCta from './useShowStickyCta'

const StickyCta = () => {
  const show = useShowStickyCta()

  return (
    <Bar $show={show} aria-hidden={!show}>
      <Info>
        <Title>PRÓ-FÍGADO</Title>
        <Sub>Frete grátis · Garantia de 7 dias</Sub>
      </Info>
      <CtaButton
        type="button"
        tabIndex={show ? 0 : -1}
        onClick={() => {
          const el = document.getElementById('pricing')
          if (el) el.scrollIntoView({ behavior: 'smooth' })
        }}
      >
        EU QUERO
      </CtaButton>
    </Bar>
  )
}

export default StickyCta
